export default __webpack_public_path__ + "static/media/app-footer-bg.6a58f158.png";